export default "__VITE_ASSET__GtBYNRi2__"